import React from "react";
import ReactGA from "react-ga";
import "./App.css";
import { HelmetProvider } from "react-helmet-async";
import { Router } from "react-router-dom";
import { history } from "./helpers";
import Routes from "./Routes";
import BudgITSnackbar from "./common/Snackbars/BudgITSnackbar";

const TRACKING_ID = "G-VH8L71M614";

ReactGA.initialize(TRACKING_ID);

const App = () => {
  React.useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <HelmetProvider>
      <BudgITSnackbar />
      <Router history={history}>
        <Routes />
      </Router>
    </HelmetProvider>
  );
};

export default App;
